(() => {
  if (window.NawiyaSafeFloatingWhatsAppCleanupLoaded) return;
  window.NawiyaSafeFloatingWhatsAppCleanupLoaded = true;

  const footer = document.querySelector('.nawiya-footer');
  const selector = [
    'a[href*="wa.me"]',
    'a[href*="api.whatsapp.com"]',
    'a[href*="whatsapp.com/send"]',
    'iframe[src*="wa.me"]',
    'iframe[src*="api.whatsapp.com"]',
    'iframe[src*="whatsapp.com/send"]',
  ].join(',');

  const findFixedRoot = (element) => {
    let node = element;

    for (
      let depth = 0;
      node && node !== document.body && depth < 8;
      depth += 1, node = node.parentElement
    ) {
      if (footer?.contains(node)) return null;

      const style = window.getComputedStyle(node);
      if (style.position === 'fixed') return node;
    }

    return null;
  };

  const cleanup = (root = document) => {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll(selector).forEach((element) => {
      if (footer?.contains(element)) return;

      const floatingRoot = findFixedRoot(element);
      if (!floatingRoot) return;

      floatingRoot.style.setProperty('display', 'none', 'important');
      floatingRoot.style.setProperty('visibility', 'hidden', 'important');
      floatingRoot.style.setProperty('pointer-events', 'none', 'important');
      floatingRoot.setAttribute('aria-hidden', 'true');
    });
  };

  const start = () => {
    cleanup();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            if (node.matches?.(selector)) cleanup(node.parentElement || document);
            cleanup(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
